<template>
  <div>
  <h2 class="titulo" style="color: #AD7E46">
    Últimos emblemas
  </h2>
    <section id="ultimos">
      <section v-for="emblema in json.data" v-bind:key="emblema.code" class="card">
         <img :src="'//habboo-a.akamaihd.net/c_images/album1584/'+ emblema.code +'.gif'" />
         <p>{{emblema.code}}</p>
         <p>{{emblema.description}}</p>
      </section>
    </section>
  </div>
</template>

<script>

export default {
  name: "Emblemas",
  data: () => ({
    json: {}
  }),
  created: function() {
    fetch('https://api.habboapi.net/badges?hotel=com.br&per_page=8').then((response) => {
      return response.json().then((json) => {
        this.json = json
      })
    })
  }
};
</script>

<style scoped>

#ultimos {
  display: flex;
  width: 100%;
  height: 80px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  font-family: 'Krub', sans-serif;
  font-weight: 600;
}

#ultimos .card {
  background-size: cover;
  border-radius: 10px;
  margin: 10px 5px;
  min-width: 200px;
  height: 50px;
  padding: 10px;
  display: inline-block;
  box-shadow: 0 1px 1px rgba(0,0,0,0.2);
  background-color: #AD7E46;
}

#ultimos .card:first-child {
  margin-left: 10px;
}

#ultimos .card:last-child {
  margin-right: 10px;
}

#ultimos .card img {
  float: left;
  padding: 5px;
  background-color: rgba(255,255,255,0.7);
  border-radius: 5px;
  margin-right: 10px;
}

#ultimos .card p {
  color: white;
  margin: 0;
  padding: 0;
  font-size: 0.80rem;
  font-weigth: 400;
  line-heigth: 0.2;
  word-break: normal;
}

</style>
